import { toaster } from "@/components/ui/toaster";
import { AppRoutes } from "@/constants/routes";
import { createFieldVisit } from "@/services/field-visit.service";
import { getAxiosErrorMessage } from "@/utils/axios-error-message";
import { handlePermissionError } from "@/utils/permission-check";
import dayjs from "dayjs";
import { AxiosError } from "axios";
import { NavigateFunction } from "react-router-dom";

interface CreateFieldVisitHandlerProps {
  navigate: NavigateFunction;
  setLoadingCreate: (v: boolean) => void;
  watchedValues: any;
  fetchPermissions: () => Promise<void>;
}

export const createFieldVisitHandler = async ({
  navigate,
  setLoadingCreate,
  watchedValues,
  fetchPermissions,
}: CreateFieldVisitHandlerProps) => {
  setLoadingCreate(true);

  try {
    const cuentaOrigen = Number(watchedValues?.account?.value);

    const selectedMotivoId = Array.isArray(watchedValues?.motivo)
      ? Number(watchedValues?.motivo?.[0])
      : undefined;
    const isOtroMotivo = selectedMotivoId === 3;

    let motivoVisita: any = undefined;
    if (isOtroMotivo) {
      motivoVisita = watchedValues?.motivoOtroDetalle;
    } else if (Array.isArray(watchedValues?.motivo)) {
      motivoVisita = watchedValues?.motivoLabel ?? watchedValues?.motivo?.[0];
    }

    const objToSend: any = {
      cuentaOrigen,
      contacto: watchedValues?.contacto,
      idProcedencia: Array.isArray(watchedValues?.procedencia)
        ? watchedValues?.procedencia?.[0]
        : undefined,
      motivoVisita,
      fechaDeseada: watchedValues?.fechaDeseada
        ? dayjs(watchedValues.fechaDeseada).format("YYYY-MM-DD")
        : undefined,
      observacionProductor: watchedValues?.observacionProductor,
    };

    if (watchedValues?.usuarioMobile?.value) {
      objToSend.idUsuarioMobile = String(watchedValues.usuarioMobile.value);
    }

    await createFieldVisit(objToSend);

    toaster.create({
      title: "Visita a campo creada con éxito",
      type: "success",
    });

    setLoadingCreate(false);
    navigate(AppRoutes.FIELD_VISIT);
  } catch (error) {
    const errorObj = error as AxiosError;

    setLoadingCreate(false);

    const handled = await handlePermissionError(
      error,
      navigate,
      fetchPermissions,
      AppRoutes.FIELD_VISIT,
    );

    if (!handled) {
      toaster.create({
        type: "error",
        title: getAxiosErrorMessage(errorObj, "No se pudo crear la visita a campo."),
      });
    }

    throw error;
  }
};
